import {
  DatePicker,
  Input,
  InputNumber,
  Label,
  Select,
  Text,
} from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { SupplyPaymentFormProps } from './supply-payment-form.type'

import { SupplierPaymentPriorityEnum, SupplyPaymentTypeEnum } from '@/types'
import styles from './supply-payment-form.module.css'

export const SupplyPaymentForm = ({
  errors,
  onChangeValues,
  values,
}: SupplyPaymentFormProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentsSupplyPaymentForm')

  const onHandleValues = (
    key: string,
    val: string | number | boolean | null | undefined,
  ) => {
    onChangeValues({ ...values, [key]: val })
  }

  return (
    <div className={styles.content}>
      <div>
        <Label required>{t('valueLabel')}</Label>
        <div className={styles.row}>
          <Select
            allowEmpty
            value={values.currency}
            options={[
              { label: 'USD', value: 'USD' },
              { label: 'MXN', value: 'MXN' },
            ]}
            onChange={(currency) => onHandleValues('currency', currency)}
            variant={errors?.currency ? 'danger' : 'primary'}
          />
          <div style={{ flex: 1 }}>
            <InputNumber
              value={values?.value}
              decimalPrecision={2}
              onChange={(value) => onHandleValues('value', value)}
              showIcons
              variant={errors?.value ? 'danger' : 'primary'}
            />
          </div>
        </div>
        {(errors?.value || errors?.currency) && (
          <Text className={styles.error}>
            {(errors.value || errors?.currency) as string}
          </Text>
        )}
      </div>

      <div>
        <Label required>{t('typeLabel')}</Label>
        <Select
          allowEmpty
          value={values.type || ''}
          options={Object.keys(SupplyPaymentTypeEnum)
            .filter((key) => key !== SupplyPaymentTypeEnum.cost_of_goods)
            .map((key) => ({
              value: key,
              label: tEnums(`supply_order_payment_type_${key}`),
            }))}
          onChange={(type) => onHandleValues('type', type)}
          error={errors?.type ? (errors.type as string) : undefined}
        />
      </div>

      <div>
        <Label>{t('paymentPriorityLabel')}</Label>
        <Select
          value={values?.paymentPriority}
          allowEmpty
          options={[
            ...Object.keys(SupplierPaymentPriorityEnum).map((key) => ({
              label: tEnums(`supply_payment_priority_${key}`),
              value: key,
            })),
          ]}
          onChange={(val) =>
            onHandleValues(
              'paymentPriority',
              val as keyof typeof SupplierPaymentPriorityEnum,
            )
          }
        />
      </div>

      <div>
        <Label>{t('expectedPaymentDateLabel')}</Label>
        <DatePicker
          value={values.expectedPaymentDate || ''}
          onChange={(type) => onHandleValues('expectedPaymentDate', type)}
          error={
            errors?.expectedPaymentDate
              ? (errors.expectedPaymentDate as string)
              : undefined
          }
        />
      </div>

      <div>
        <Label>{t('observationLabel')}</Label>
        <Input
          value={values.observation || ''}
          onChange={(observation) => onHandleValues('observation', observation)}
          error={
            errors?.observation ? (errors.observation as string) : undefined
          }
        />
      </div>
    </div>
  )
}
